import React, { Component } from 'react';
import Titulo from '../../components/Texto/Titulo';
import InputSimples from '../../components/Inputs/Simples';
import Voltar from '../../components/Links/Voltar';

import { connect } from 'react-redux';
import * as actions from '../../actions/upsells';
import AlertGeral from '../../components/Alert/Geral';

import SingleImage from '../../components/Imagens/Single';
import { formatMoneyOnChange } from '../../utils';
import { formatMoney } from '../../actions';
import erpApi from '../../services/erpApi';

class NovoUpsell extends Component {

  state = {
    titulo: "",
    preco: "",
    erpId: "",
    aviso: null,
    fotos: "",
    erros: {},
    imageTemp: null,
    erpConsultaLoading: false,
    erpConsultaResultado: null
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState && prevState.imageTemp !== this.state.imageTemp){
      console.log(this.state.imageTemp)
    }
  }

  handleImageUpload = (ev) => {
    const data = new FormData();
    data.append("files", ev.target.files[0]);

    return this.setState({ imageTemp: URL.createObjectURL(ev.target.files[0]), fotos: data });
  }

  consultarERP = async () => {
    const { erpId } = this.state;
    
    if (!erpId) {
      this.setState({ 
        aviso: { 
          status: false, 
          msg: "Informe um ID no ERP para consultar" 
        } 
      });
      return;
    }
    
    this.setState({
      erpConsultaLoading: true,
      erpConsultaResultado: null,
      aviso: null
    });
    
    try {
      const resultado = await erpApi.getProdutoByCodigo(erpId);
      
      if (resultado.success) {
        this.setState({
          erpConsultaResultado: resultado.data,
          erpConsultaLoading: false,
          aviso: {
            status: true,
            msg: "Produto encontrado no ERP com sucesso!"
          }
        });
        
        // Auto-preencher campos com dados do ERP
        if (resultado.data && resultado.data.length > 0) {
          const produtoERP = resultado.data[0];
          this.setState({
            titulo: produtoERP.nome || this.state.titulo,
            preco: produtoERP.preco ? formatMoney(produtoERP.preco) : this.state.preco
          });
        }
      } else {
        this.setState({
          erpConsultaLoading: false,
          aviso: {
            status: false,
            msg: resultado.error?.message || "Produto não encontrado no ERP ou erro na consulta"
          }
        });
      }
    } catch (error) {
      this.setState({
        erpConsultaLoading: false,
        aviso: {
          status: false,
          msg: `Erro ao consultar ERP: ${error.message}`
        }
      });
    }
  }

  renderErpConsultaResultado = () => {
    const { erpConsultaResultado } = this.state;
    
    if (!erpConsultaResultado || erpConsultaResultado.length === 0) return null;
    
    const produto = erpConsultaResultado[0];
    
    return (
      <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #e9ecef' }}>
        <h4 style={{ fontSize: '14px', marginBottom: '8px', color: '#28a745' }}>Produto encontrado no ERP</h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
          {produto.codigo && (
            <div>
              <strong>Código:</strong> {produto.codigo}
            </div>
          )}
          {produto.nome && (
            <div>
              <strong>Nome:</strong> {produto.nome}
            </div>
          )}
          {produto.preco !== undefined && (
            <div>
              <strong>Preço:</strong> {formatMoney(produto.preco)}
            </div>
          )}
          {produto.quantidade !== undefined && (
            <div>
              <strong>Estoque:</strong> {produto.quantidade}
            </div>
          )}
        </div>
      </div>
    );
  }

  validate(){
    const { titulo, preco } = this.state;
    const erros = {};

    if(!titulo) erros.titulo = "Preencha aqui com o titulo";
    if(!preco) erros.preco = "Preencha aqui com o preço";

    this.setState({ erros });
    return !( Object.keys(erros).length > 0 );
  }

  handleAdd(){
    if(!this.validate()) return null;
    this.props.criarUpsell(this.state, this.props.usuario?.loja, (error, upsell) => {
      this.setState({ aviso: { status: !error, msg: error ? error.message : "Upsell criado com sucesso" } });
        
      if(!error) {
        this.props.updateUpsellImage(this.state.fotos, upsell._id, upsell.loja, () => {
          window.scrollTo(0, 0);
          this.props.history.push("/upsells")
        })
      }
    });
  }

  onChangeInput = (field, value) => this.setState({ [field]: value }, () => this.validate())

  renderDados(){
    const { titulo, preco, erpId, erros, erpConsultaLoading } = this.state;
    return (
      <div className="novoUpsell">
        <SingleImage image={this.state.imageTemp} temp={true} handleSubmit={this.handleImageUpload} />
        <div className="fields">
          <InputSimples
            label="Titulo"
            value={titulo}
            error={erros.titulo}
            onChange={(ev) => this.onChangeInput("titulo", ev.target.value)} />
          <InputSimples label="Preço" value={preco} error={erros.preco} onChange={(ev) => this.onChangeInput("preco", formatMoneyOnChange(ev.target.value))} />
          
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ 
              backgroundColor: erpId ? '#e6f7ed' : '#fff3e0', 
              padding: '10px', 
              borderRadius: '4px', 
              marginBottom: '10px',
              border: erpId ? '1px solid #a3d8b5' : '1px solid #ffe0b2'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '5px',
                color: erpId ? '#2e7d32' : '#e65100'
              }}>
                <i className={erpId ? "fas fa-check-circle" : "fas fa-exclamation-triangle"} 
                   style={{ marginRight: '8px' }}></i>
                <strong>{erpId ? "Integração com ERP configurada" : "Atenção! Upsell sem integração com ERP"}</strong>
              </div>
              <p style={{ fontSize: '12px', margin: '0' }}>
                {erpId 
                  ? "Este upsell está corretamente configurado para integração com o ERP." 
                  : "Upsells sem ID no ERP não poderão ser integrados automaticamente nas vendas."}
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              <div style={{ flex: 1 }}>
                <InputSimples 
                  label="ID no ERP" 
                  error={erros.erpId} 
                  value={erpId || ""}
                  onChange={(e) => this.onChangeInput("erpId", e.target.value)}
                  style={{ 
                    borderColor: erpId ? '#a3d8b5' : '#ffe0b2',
                    backgroundColor: erpId ? '#f5fff9' : '#fffaf0'
                  }}
                />
              </div>
              <div style={{ marginTop: '40px' }}>
                <button 
                  onClick={this.consultarERP}
                  disabled={erpConsultaLoading}
                  style={{ 
                    padding: '6px 12px', 
                    backgroundColor: '#f0f0f0', 
                    color: '#333', 
                    border: '1px solid #ccc', 
                    borderRadius: '4px',
                    cursor: erpConsultaLoading ? 'wait' : 'pointer',
                    fontSize: '13px'
                  }}
                >
                  {erpConsultaLoading ? 'Consultando...' : 'Consultar'}
                </button>
              </div>
            </div>
          </div>
          
          {this.renderErpConsultaResultado()}
        </div>
      </div>
    )
  }

  render(){
    return (
      <div className="container-centered">
        <div className="head">
          <Voltar history={this.props.history} />
          <AlertGeral aviso={this.state.aviso} />
        </div>
        <div className="Page-Title">
          <Titulo tipo="h1" titulo="Novo Upsell" />
        </div>
        { this.renderDados() }
        <div className="ButtonSubmit">
          <button onClick={() => this.handleAdd()}>Adicionar</button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  produto: state.produto.produto,
  categorias: state.categoria.categorias,
  usuario: state.auth.usuario
});

export default connect(mapStateToProps, actions)(NovoUpsell);